import { render, staticRenderFns } from "./equipment-card-controls.vue?vue&type=template&id=087b717d&"
import script from "./equipment-card-controls.vue?vue&type=script&lang=js&"
export * from "./equipment-card-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports